import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function Thanks() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="thanks-page">
      <div className="thanks-container">
        <h1>Thanks! 🎉</h1>
        <p>Your message landed. We'll get back to you soon.</p>
        <p>Redirecting to home in 5 seconds...</p>
        <p>
          <Link to="/" className="btn">Back to home now</Link>
        </p>
      </div>
    </div>
  );
}

export default Thanks;
